var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 8H15","stroke":"#999999","stroke-width":"1.5","stroke-linecap":"square"}}),_c('path',{attrs:{"d":"M8 1L8 15","stroke":"#999999","stroke-width":"1.5","stroke-linecap":"square"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }